import { render, staticRenderFns } from "./reportStep1.vue?vue&type=template&id=70ccb51f&scoped=true"
import script from "./reportStep1.vue?vue&type=script&lang=js"
export * from "./reportStep1.vue?vue&type=script&lang=js"
import style0 from "./reportStep1.vue?vue&type=style&index=0&id=70ccb51f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ccb51f",
  null
  
)

export default component.exports